module.exports = __webpack_public_path__ + "static/img/nsfwBg.5252f79c.webp";